import React, { useState } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

const RouterDebugger = ({ pageData = {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  return (
    <div className="debug">
      {isOpen && (
        <div className="debug__content">
          <table>
            <tbody>
              <tr>
                <th>
                  <span>Pathname</span>
                </th>
                <th>{router.pathname}</th>
              </tr>
              <tr>
                <th>
                  <span>Route</span>
                </th>
                <th>{router.route}</th>
              </tr>
              <tr>
                <th>
                  <span>As path</span>
                </th>
                <th>{router.asPath}</th>
              </tr>
            </tbody>
          </table>

          <button
            type="button"
            onClick={() => {
              console.log('query:', router.query);
            }}
            className="debug__log"
          >
            Log Query
          </button>
          <button
            type="button"
            onClick={() => {
              console.log('pageData:', pageData);
            }}
            className="debug__log"
          >
            Log Pagedata
          </button>
        </div>
      )}
      <button type="button" onClick={() => setIsOpen(prev => !prev)} className="debug__toggle">
        {isOpen ? 'Close Router' : 'Open Router'}
      </button>
      <style jsx>
        {`
          .debug {
            font-family: sans-serif;
            font-size: 14px;
            position: fixed;
            bottom: 20px;
            left: 20px;
            display: flex;
            align-items: flex-end;
            flex-direction: column;
            z-index: 999;
          }

          .debug__toggle {
            height: 40px;
            font-family: sans-serif;
            background: none;
            display: flex;
            align-items: center;
            justify-content: center;
            align-self: flex-start;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            box-shadow:
              0 11px 40px 0 rgba(0, 0, 0, 0.1),
              0 2px 10px 0 rgba(0, 0, 0, 0.1);
            text-transform: uppercase;
            font-weight: bold;
            padding: 5px 10px;
            background: white;
          }

          .debug__toggle:active {
            color: black;
          }

          .debug__log {
            display: block;
            width: 100%;
            border: none;
            background: #f4f4f4;
            padding: 10px;
            font-weight: bold;
            text-transform: uppercase;
            cursor: pointer;
            margin: 5px 0 0;
          }

          .debug__log:active,
          .debug__log:focus,
          .debug__log:hover {
            background: #adadad;
            color: black;
          }

          svg {
            width: 20px;
            height: 20px;
          }

          .debug__content {
            border-radius: 5px;
            min-width: 150px;
            padding: 15px;
            background: white;
            margin-bottom: 10px;
            box-shadow:
              0 11px 40px 0 rgba(0, 0, 0, 0.1),
              0 2px 10px 0 rgba(0, 0, 0, 0.1);
          }

          table {
            margin-bottom: 20px;
            width: 100%;
          }

          span {
            text-transform: uppercase;
            font-size: 10px;
            font-weight: bold;
            color: #adadad;
            margin-right: 5px;
          }

          th:first-of-type {
            text-align: left;
          }

          th:last-of-type {
            text-align: right;
            font-weight: normal;
          }
        `}
      </style>
    </div>
  );
};

RouterDebugger.propTypes = {
  pageData: PropTypes.shape()
};

export default RouterDebugger;
